import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';

class SimpleTooltip extends Component {
	constructor(props) {
	    super(props);
		this.state = {
		    tooltipOpen: false
	    };
	}

	toggle() {
	    this.setState({
	      tooltipOpen: !this.state.tooltipOpen,
	    });
	}
	render() {
		return (
			<Tooltip 
				placement={this.props.tooltipPlacement? this.props.tooltipPlacement : 'right'} 
				isOpen={this.state.tooltipOpen} 
				target={ this.props.target } 
				toggle={() => {this.toggle()}}>
				{ this.props.text }
			</Tooltip>	
		);
	}
}
export default SimpleTooltip;


// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SimpleTooltip.js